import { Cart, getStaticProps } from '@public/Showroom/Cart'

export { getStaticProps }

export default Cart
